import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialInstitutionFinanceState: Dtos.InstitutionFinance & IRegistrationFormState = {
    id: null,
    institutionId: null,
    institution: null,
    bctInvoicingPrefix: null,
    taxInvoiceName: null,
    quickbooksTaxCodeId: null,
    quickbooksTaxCode: null,
    fundingEmailAddress: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    sourceDocuments: []
}

export interface IInstitutionFinanceReduxFormState {
    id: IFieldState<number>,
    institutionId: IFieldState<number>,
    institution: IFieldState<Dtos.Institution>,
    bctInvoicingPrefix: IFieldState<string>,
    taxInvoiceName: IFieldState<string>,
    quickbooksTaxCodeId: IFieldState<number>,
    quickbooksTaxCode: IFieldState<Dtos.QuickbooksTaxCode>,
    fundingEmailAddress: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    sourceDocuments: IFieldState<Dtos.SourceDocument[]>
}
